import { Button, Typography, Card, Space, Alert } from 'antd';
import { useHistory } from 'react-router-dom';
import { WarningOutlined } from '@ant-design/icons';
import '../styles/login.scss';

const { Title, Paragraph } = Typography;

export const AccountDeletionInfo = () => {
    const history = useHistory();

    return (
        <div className="login-container">
            <Card style={{ maxWidth: 700, margin: '0 auto', padding: '16px' }}>
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                    <div style={{ textAlign: 'center' }}>
                        <WarningOutlined
                            style={{ fontSize: 48, color: '#ff4d4f', marginBottom: 12 }}
                        />
                        <Title level={3} style={{ marginBottom: 4, marginTop: 0 }}>
                            Delete Your Account
                        </Title>
                    </div>

                    <Alert
                        message="Important Information"
                        description="Deleting your account is permanent and cannot be undone after the grace period."
                        type="warning"
                        showIcon
                    />

                    <div>
                        <Title level={4} style={{ marginBottom: 8 }}>
                            What happens when you delete your account?
                        </Title>
                        <Paragraph>
                            <ul style={{ paddingLeft: 20, marginTop: 8 }}>
                                <li>All your transactions and data will be permanently deleted</li>
                                <li>Your documents and files will be removed</li>
                                <li>Your email templates and signatures will be deleted</li>
                                <li>All calendar events and integrations will be disconnected</li>
                                <li>Your subscription will be cancelled</li>
                                <li>Access for all sub-users will be revoked</li>
                            </ul>
                        </Paragraph>
                    </div>

                    <div>
                        <Title level={4} style={{ marginBottom: 8 }}>
                            Grace Period - 14 Days
                        </Title>
                        <Paragraph style={{ marginBottom: 8 }}>
                            You have <strong>14 days (2 weeks)</strong> to change your mind. During
                            this period, you can log back in and cancel the deletion request to
                            reactivate your account with all your data intact.
                        </Paragraph>
                        <Paragraph style={{ marginBottom: 0 }}>
                            After 14 days, your account and all associated data will be permanently
                            deleted and cannot be recovered.
                        </Paragraph>
                    </div>

                    <div>
                        <Title level={4} style={{ marginBottom: 8 }}>
                            Ready to proceed?
                        </Title>
                        <Paragraph style={{ marginBottom: 0 }}>
                            You must be logged in to confirm account deletion.
                        </Paragraph>
                    </div>

                    <Space style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}>
                        <Button size="large" onClick={() => history.push('/')}>
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            danger
                            size="large"
                            onClick={() => history.push('/login?redirect=delete-account-confirm')}
                        >
                            Log In to Continue
                        </Button>
                    </Space>
                </Space>
            </Card>
        </div>
    );
};
